export default __webpack_public_path__ + "static/media/down_select.1dada0fc.svg";